import { getAppropriateDecimals } from '@benzinga/utils';

export const formatPortfolioCurrency = (value: number): string =>
  Intl.NumberFormat('en-US', {
    currency: 'USD',
    maximumFractionDigits: value >= 1000 ? 0 : 2,
    style: 'currency',
  }).format(value);

export const formatHoldingCurrency = (value: number): string =>
  Intl.NumberFormat('en-US', {
    currency: 'USD',
    maximumFractionDigits: 2,
    style: 'currency',
  }).format(value);

export const formatQuoteChangeCurrency = (value: number): string => {
  if (!Number.isFinite(value) || value === 0) return formatHoldingCurrency(0);

  const fractionDigits = Math.abs(value) >= 0.005 ? 2 : getAppropriateDecimals(value);
  return new Intl.NumberFormat('en-US', {
    currency: 'USD',
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: Math.min(2, fractionDigits),
    signDisplay: 'auto',
    style: 'currency',
  }).format(value);
};

export const formatSignedCurrency = (value: number): string =>
  `${value >= 0 ? '+' : '−'}${formatHoldingCurrency(Math.abs(value))}`;

export const formatSignedPercent = (value: number): string => `${value >= 0 ? '+' : '−'}${Math.abs(value).toFixed(2)}%`;

export const hasKnownHoldingGain = (hasPrice: boolean, costBasis: number, gain: number): boolean =>
  hasPrice && costBasis > 0 && Math.abs(gain) >= 0.005;

export const signedChangeClassName = (
  value: number,
  format: 'currency' | 'percentage' = 'currency',
): string => {
  const isFlat = format === 'percentage' ? Math.abs(value) < 0.005 : value === 0;
  if (isFlat) return 'text-slate-500';
  return value > 0 ? 'text-bzgreen-500' : 'text-bzred-500';
};
